import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { DASHBOARD_ADMIN_DELETE_ATTACHMENT_API } from "./apiRoutes";

interface mutateProps {
  projectId: string;
  taskId: string;
  attachmentId: string;
}

const mutateDeleteClientAttachment = async ({projectId, taskId, attachmentId}: mutateProps) => {
  return await axiosAuth.delete(DASHBOARD_ADMIN_DELETE_ATTACHMENT_API(projectId, taskId, attachmentId));
};

const useDeleteClientAttachmentMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateDeleteClientAttachment,
    ...queryParams,
  });

export default useDeleteClientAttachmentMutation;
